import axios from 'axios';

/** Send chat messages to AI and get structured response */
export async function sendChatMessage(messages) {
  const { data } = await axios.post('/api/coresignal/chat', { messages });
  return data; // { type: 'filter'|'chat', filters?, message }
}

/** 
 * Search Coresignal using agentic_search/fast — returns lightweight profiles directly.
 * No collect call needed for the table!
 */
export async function searchCandidates(filters, after = null) {
  const { data } = await axios.post('/api/coresignal/search', { filters, after });
  return { 
    profiles: data.profiles || [], 
    total: data.total || 0, 
    nextCursor: data.nextCursor || null,
    totalResults: data.totalResults || 0 
  };
}

/** 
 * Enrich a single candidate by ID — calls collect API for full profile data.
 * Only called when user clicks a candidate in the sidebar.
 */
export async function enrichCandidate(id) {
  const { data } = await axios.get(`/api/coresignal/enrich/${id}`);
  return data;
}

/** Fetch sourcing history for the user (optionally scoped to a job) */
export async function getHistory(jobId) {
  const url = jobId ? `/api/coresignal/history?jobId=${jobId}` : '/api/coresignal/history';
  const { data } = await axios.get(url);
  return data;
}

/** Delete a sourcing history session by id */
export async function deleteHistory(id) {
  const { data } = await axios.delete(`/api/coresignal/history/${id}`);
  return data;
}

/** Save or update sourcing history session */
export async function saveHistory(payload) {
  const { data } = await axios.post('/api/coresignal/history', payload);
  return data;
}

/** Upload JD file to parse into search filters */
export async function uploadJD(file) {
  const formData = new FormData();
  formData.append('file', file);
  const { data } = await axios.post('/api/coresignal/parse-jd', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
  return data; // { filters, summary }
}

/** Score a batch of candidates against JD filters (background, non-blocking) */
export async function scoreCandidates(candidates, filters) {
  const { data } = await axios.post('/api/coresignal/score-candidates', { candidates, filters });
  return data.scores || []; // [{ id, fitScore, reasons }]
}

/** Fetch candidate email via ContactOut API */
export async function fetchCandidateEmail(linkedinUrl, name, company, sessionId = null, candidateId = null) {
  const { data } = await axios.post('/api/coresignal/fetch-email', { linkedinUrl, name, company, sessionId, candidateId });
  return data; // { email, emailType, allEmails, phones }
}

/**
 * A candidate's mobile: Apollo reveal first (phoneStatus 'pending' until Apollo's webhook
 * delivers it — poll again), then ContactOut when allowFallback is true.
 */
export async function fetchCandidatePhone(linkedinUrl, sessionId = null, candidateId = null, allowFallback = true) {
  const { data } = await axios.post('/api/coresignal/fetch-phone', { linkedinUrl, sessionId, candidateId, allowFallback });
  return data; // { phone, phones, phoneStatus: 'found' | 'pending' | 'not_found', email, emailType, provider }
}

/** Send outreach emails to candidates */
export async function sendOutreachEmails(recipients, subject, body, fromEmail, sessionId) {
  const { data } = await axios.post('/api/coresignal/send-outreach', { recipients, subject, body, fromEmail, sessionId });
  return data; // { results, totalSent, totalFailed }
}

